export const ADD_POINTS = "ADD_POINTS";
export const GET_POINTS = "GET_POINTS";

export const HIDE_PASTAS = "HIDE_PASTAS";
export const SHOW_PASTAS = "SHOW_PASTAS";

export const GAME_RUNNING = "GAME_RUNNING";
export const GAME_STOPPING = "GAME_STOPPING";
